import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

// Employee Types
export function* getEmployeeTypes(action: any): any {
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.GET_EMPLOYEE_TYPES, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.USER_MANAGEMENT.GET_EMPLOYEE_TYPES, action.payload, true, yieldPuts);
}

export function* updateEmployeeTypes(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.UPDATE_EMPLOYEE_TYPES, action.payload, true);
}

export function* deleteEmployeeTypes(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.DELETE_EMPLOYEE_TYPES, action.payload, true);
}

// Pay Types
export function* getPayTypes(action: any): any {
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.GET_PAY_TYPES, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.USER_MANAGEMENT.GET_PAY_TYPES, action.payload, true, yieldPuts);
}

export function* updatePayTypes(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.UPDATE_PAY_TYPES, action.payload, true);
}

export function* deletePayTypes(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.DELETE_PAY_TYPES, action.payload, true);
}

export function* searchUsers(action: any): any {
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.SEARCH_USERS, payload: "users" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.SEARCH_USERS, action.payload, true, yieldPuts);
}

export function* insertUpdateUser(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.INSERT_UPDATE_USER, action.payload, true);
}

export function* deleteUser(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.DELETE_USER, action.payload, true);
}

export function* getUserDetails(action: any): any {
    // The API expects integer ID, so we need to decode the base64 ID from the payload
    const decodedId = action.payload;
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.GET_USER_DETAILS, payload: "item" }];
    yield call(sagaFunction, action, CallApi.GET, `${APIS.USER_MANAGEMENT.GET_USER_DETAILS}${decodedId}`, null, true, yieldPuts);
}

export function* getUserSchedule(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.USER_MANAGEMENT.GET_USER_SCHEDULE, action.payload, true);
}

export function* searchUserSchedule(action: any): any {
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.SEARCH_USER_SCHEDULE, payload: "schedules" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.SEARCH_USER_SCHEDULE, action.payload, true, yieldPuts);
}

export function* insertUpdateUserSchedule(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.INSERT_UPDATE_USER_SCHEDULE, action.payload, true);
}

export function* getUserScheduleById(action: any): any {
    const { userId, locationId, userScheduleId } = action.payload;
    yield call(sagaFunction, action, CallApi.GET, APIS.USER_MANAGEMENT.GET_USER_SCHEDULE_BY_ID, { userId, locationId, userScheduleId }, true);
}

export function* validateMpin(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.VALIDATE_MPIN, action.payload, true);
}

// Role Permissions
export function* getRolePermission(action: any): any {
    // The API expects integer ID, so we need to decode the base64 ID from the payload
    const decodedId = action.payload?.id;
    yield call(sagaFunction, action, CallApi.GET, `${APIS.USER_MANAGEMENT.GET_ROLE_PERMISSION}/${decodedId}`, null, true);
}

export function* getRoleList(action: any): any {
    const yieldPuts = [{ type: ACTIONS.USER_MANAGEMENT.ROLE_LIST, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.USER_MANAGEMENT.ROLE_LIST, action.payload, true, yieldPuts);
}

export function* insertUpdateRolePermission(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.INSERT_UPDATE_ROLE_PERMISSION, action.payload, true);
}

export function* deleteRolePermission(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.USER_MANAGEMENT.DELETE_ROLE_PERMISSION, action.payload, true);
}
